import { Modal } from 'react-bootstrap'
import { useState, useEffect } from 'react'

import { toast } from 'react-toastify'
import { ToastMessageContainer } from '../../../../../../_ePulse/layout/components/ToastMessageContainer'
import useApi from '../../../../../../hooks/useQuery'
import { ADD_NEW_LAB_ROOM, GET_SELECTED_PRODUCTS, UPDATE_LAB_ROOM } from '../../../GraphQLQueries/ProductOffering'
import useMutationApi from '../../../../../../hooks/useMutation'
import { stringify } from 'querystring'

export const EditLabModal = (props: any) => {
  const [labName, setLabName] = useState(props.labData?.roomName);
  const [labType, setLabType] = useState(props.labData?.roomType);
  const [labId, setLabId] = useState(props.labData?.labId);

  const { createData, loading, error, data } = useMutationApi(UPDATE_LAB_ROOM);

  const editCallAPI= async()=>{
    try{
        await createData({labRoomId:labId, testLabsInput:{ 
            roomName:labName,
            roomType: props.labData?.roomType,
            roomTypeId: props.labData?.roomTypeId
        }});
        props.closeModal();
    }catch(err){
        toast.error(`Error editing Lab ${props.labData?.labName}`);
        console.log("Error deleting lab ",err);
    }
  }

  return (
    <Modal
      show={true}
      dialogClassName='ePulse-modal ePulse-modal-50w'
      onHide={() => props.closeModal()}
      backdrop='static'
    >
      <Modal.Header className='border-0' closeButton>
        <div>
          <ToastMessageContainer />
        </div>
        <span className='fs-3 fw-bold'>Edit Lab</span>
      </Modal.Header>
      <Modal.Body className='container' />
      <div className='ePulse-modal-content'>
        <div className='modal-body'>
          <div className='form-group'>
            <label>Lab Name</label>
            <input
              type='text'
              className='form-control'
              placeholder='Enter Lab Name'
              value={labName}
              onChange={(e) => setLabName(e.target.value)}
            />
          </div>
          <div className='form-group'>
            <label>Products Offered</label>
            <input
              disabled={true}
              type='text'
              className='form-control'
              placeholder='Enter Lab Name'
              value={labType}
            />
          </div>
        </div>

        <div className='btn-row'>
            <button
            className='ePulse-btn-primary'
            type='button'
            onClick={editCallAPI}
            >
             Update 
            </button>
        </div>
      </div>
    </Modal>
  )
}